import useBranding from "../branding/useBranding";

const ADLinks: { [key: string]: string } = {
  default: "https://sso.skyresponse.com",
  skyresponse: "https://sso.skyresponse.com",
  hepro: "https://login.skyresponse.com/?brand=hepro",
  careium: "https://login.skyresponse.com/?brand=careium",
  zafe: "https://login.skyresponse.com/?brand=zafe",
  viser: "https://login.skyresponse.com/?brand=viser",
  telealarm: "https://login.skyresponse.com/?brand=telealarm",
  chubb: "https://login.skyresponse.com/?brand=chubb",
  curena: "https://login.skyresponse.com/?brand=curena",
};

export const useADLoginLink = () => {
  const brandingData = useBranding();
  const getADLoginLink = () => {
    if (process.env.REACT_APP_ENVIRONMENT === "dev") {
      return "https://sso.dev.skyresponse.com/";
    }
    if (process.env.REACT_APP_ENVIRONMENT === "stage") {
      return "https://sso-stage.skyresponse.com/";
    }
    return ADLinks[brandingData.customerKey];
  };
  return getADLoginLink;
};
